







































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import ChangePassword from '@/components/shared/ChangePassword.vue'
import { defaultTheme, dartyProThemes, dartyThemes, mgdThemes } from './plugins/vuetify';


@Component({
  name:"App",
  components:{ChangePassword}
})
export default class App extends Vue {
  private clipped = true
  private drawer = true
  private miniVariant = false
  private right = true
  private title = 'ASP.NET Core Vue Starter'
  private openUserMenu = false  
  
  onResize(){
    //@ts-ignore
    this.$store.myActions.UI_SET_CONTENT_HEIGHT(window.innerHeight - this.$refs.appBar.$el.clientHeight - 20)            
  }

  mounted(){
    this.onResize()
  }

  get isAuthenticated(){
    return this.$store.myGetters.isAuthenticated
  }

  get curEnsId(){
    return this.$store.myGetters.userProfile.ensId || 0
  }  

  get logo(){
    switch(this.curEnsId){
      case 1: //darty
        return require('@/assets/logo_dty.png')
      case 2: //mgd
        return require('@/assets/logo_mgd.png')
      case 3: //darty-pro
        return require('@/assets/logo_dtp.png')
      default:
        return ''
    }     
  }

  @Watch("curEnsId")
  curEnsIdChanged(newValue:number) {    
    switch(newValue)    {
      case 1: //darty
        //@ts-ignore    
        this.$vuetify.theme.themes.light = dartyThemes.light        
        break;
      case 2: //mgd
        //@ts-ignore
        this.$vuetify.theme.themes.light = mgdThemes.light
        break;
      case 3: //darty-pro
        //@ts-ignore
        this.$vuetify.theme.themes.light = dartyProThemes.light        
        break;
      default:
        //@ts-ignore
        this.$vuetify.theme.themes.light = defaultTheme.light
        break;
    }    
  }



  get userName(){
    return this.$store.myGetters.userProfile.prsPrenom + " " + this.$store.myGetters.userProfile.prsNom
  }

  get showSnacks() {
     return this.$store.myGetters.snackMessages.length > 0
  }

  set showSnacks(newValue) {
    this.$store.myActions.UI_CLOSE_SNACKBAR()
  }

  get showErrors() {
     return this.$store.myGetters.errorMessages.length > 0
  }  

  set showErrors(newValue) {
    this.$store.myActions.UI_CLOSE_ERROR()
  }

  get errorMessages(){
    return this.$store.myGetters.errorMessages
  }
    
  get snackMessages(){
    return this.$store.myGetters.snackMessages
  }

  get isDarty(){
    return this.$store.myGetters.isDarty
  }
  get isDartyPro(){
    return this.$store.myGetters.isDartyPro
  }
  

  get isCentralWeb(){
    return this.$store.myGetters.isCentralWeb
  }

  get isAdmin(){
    return this.$store.myGetters.isAdmin
  }
  

  private get groups(){
    return [
      {title: 'Partenaires', open:true, icon: 'mdi-account-multiple' ,link: {name:"Partenaires"}, visible:true},
      {title: 'Flux de données', icon: 'mdi-file-export',link: {name:"Flux"}, visible:true},
      { title: 'Groupe de caractéristiques', icon: 'mdi-format-list-group', link: {name:'GroupCarac'} , visible:!this.isDartyPro},
      { title: 'Profils d\'exclusion', icon: 'mdi-filter-variant', link: {name:'ProfilExclusion'} , visible:this.isDartyPro},
      {title: 'Outils', open:true, icon: 'mdi-tools', items : [
        { title: 'Information sur CODIC', icon: '', link: '/codic' , visible:true},
        { title: 'Renommage facettes', icon: 'mdi-touch-app', link: {name:'Facette'} , visible:this.isDarty}
      ], visible:true},
      {title: 'Administration', open:true, icon: 'mdi-cogs', items : [
        { title: 'Gestion des utilisateurs', icon: '', link: {name:"Personne"} , visible:true}     
      ], visible:this.isCentralWeb || this.isAdmin},
      {title: 'CentralWeb', open:true, icon: 'mdi-web', items : [
        { title: 'Data source', icon: '', link: {name:"DataSources"} , visible:true},
        { title: 'Méta-données', icon: '', link:  {name:"Metas"} , visible:true},
        { title: 'Flux builders', icon: '', link:  {name:"FluxBuilders"} , visible:true},      
        { title: 'Feed downloads', icon: '', link:  {name:"FeedDownloads"} , visible:true},      
        { title: 'Liste de générations', icon: '', link: '/generations', visible:true },
        { title: 'Configuration info codic', icon: '', link: '/config-codic', visible:true },
        { title: 'Visualisation des logs', icon: '', link: '/logs', visible:true }
      ], visible:this.isCentralWeb},
    ];  
  }

  logout() {           
    this.$store.myActions.AUTH_LOGOUT_REQUEST()
  }

  changePassword() { (this.$refs.changePassword as ChangePassword).edit() }

}
